import React from "react";
import { Alert, Grid, Skeleton, Typography } from "@mui/material";
import SimilarSeasonCard from "./SimilarSeasonCard";

const DEFAULT_INELIGIBLE =
  "This season is not in the similarity index. Short samples and seasons missing steals, blocks, or turnovers are excluded.";
const DEFAULT_EMPTY = "No similar seasons found.";
const DEFAULT_ERROR = "Could not load similar seasons.";

const SimilarSeasonsList = ({
  items = [],
  isLoading = false,
  error = null,
  onSelect,
  ineligibleMessage = DEFAULT_INELIGIBLE,
  emptyMessage = DEFAULT_EMPTY,
  errorMessage = DEFAULT_ERROR,
}) => {
  if (isLoading) {
    return (
      <Grid container spacing={1.5}>
        {[1, 2, 3, 4].map((key) => (
          <Grid item xs={12} md={6} key={key}>
            <Skeleton variant="rounded" height={148} />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (error?.status === 404) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
        {ineligibleMessage}
      </Typography>
    );
  }

  if (error) {
    return <Alert severity="warning">{errorMessage}</Alert>;
  }

  if (items.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Grid container spacing={1.5}>
      {items.map((item) => (
        <Grid item xs={12} md={6} key={item.key}>
          <SimilarSeasonCard item={item} onSelect={onSelect} />
        </Grid>
      ))}
    </Grid>
  );
};

export default SimilarSeasonsList;
